import * as tslib_1 from "tslib";
import { Field, Attr } from '@swim/recon';
import { DirectiveForm } from './directive-form';
import { StyleDirective } from './style-directive';
var StyleForm = (function (_super) {
    tslib_1.__extends(StyleForm, _super);
    function StyleForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StyleForm.prototype, "tag", {
        get: function () {
            return 'style';
        },
        enumerable: true,
        configurable: true
    });
    StyleForm.prototype.cast = function (item) {
        if (item.tag === this.tag) {
            var directive_1 = new StyleDirective();
            item.forEach(function (item) {
                this.materializeDirectiveParam(directive_1, item);
            }, this);
            return directive_1;
        }
        return undefined;
    };
    StyleForm.prototype.materializeDirectiveParam = function (directive, item) {
        if (item instanceof Attr && item.key.value === this.tag) {
            return;
        }
        else if (item instanceof Field) {
            directive._bindings.push(item);
        }
    };
    StyleForm.Form = new StyleForm();
    return StyleForm;
}(DirectiveForm));
export { StyleForm };
DirectiveForm.addGlobal(StyleForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGUtZm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0eWxlLWZvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBTyxLQUFLLEVBQUUsSUFBSSxFQUFDLE1BQU0sYUFBYSxDQUFDO0FBQzlDLE9BQU8sRUFBQyxhQUFhLEVBQUMsTUFBTSxrQkFBa0IsQ0FBQztBQUMvQyxPQUFPLEVBQUMsY0FBYyxFQUFDLE1BQU0sbUJBQW1CLENBQUM7QUFHakQ7SUFBK0IscUNBQTZCO0lBQTVEOztJQXlCQSxDQUFDO0lBeEJDLHNCQUFJLDBCQUFHO2FBQVA7WUFDRSxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQ2pCLENBQUM7OztPQUFBO0lBRUQsd0JBQUksR0FBSixVQUFLLElBQVU7UUFDYixFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQzFCLElBQU0sV0FBUyxHQUFHLElBQUksY0FBYyxFQUFFLENBQUM7WUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLElBQVU7Z0JBQy9CLElBQUksQ0FBQyx5QkFBeUIsQ0FBQyxXQUFTLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDbEQsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO1lBQ1QsTUFBTSxDQUFDLFdBQVMsQ0FBQztRQUNuQixDQUFDO1FBQ0QsTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRUQsNkNBQXlCLEdBQXpCLFVBQTBCLFNBQXlCLEVBQUUsSUFBVTtRQUM3RCxFQUFFLENBQUMsQ0FBQyxJQUFJLFlBQVksSUFBSSxJQUFJLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQ3hELE1BQU0sQ0FBQztRQUNULENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDakMsU0FBUyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDakMsQ0FBQztJQUNILENBQUM7SUFFZSxjQUFJLEdBQUcsSUFBSSxTQUFTLEVBQUUsQ0FBQztJQUN6QyxnQkFBQztDQUFBLEFBekJELENBQStCLGFBQWEsR0F5QjNDO1NBekJZLFNBQVM7QUEwQnRCLGFBQWEsQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDIn0=